export default {"src":"/_next/static/media/sparkle_64.ef66fc69.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};